module.exports = __webpack_public_path__ + "img/auto-bg-2.73963790.jpg";